module.exports = __webpack_public_path__ + "img/long-neck-3.14d369de.png";